import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosConfig from 'src/axiosConfig'

export const loginUser = createAsyncThunk('auth/login', async ({ email, password }) => {
  const response = await axiosConfig.post('/auth/login', { email, password })
  sessionStorage.setItem('accessToken', response.data.access_token)
  return response.data
})

export const getUserInfo = createAsyncThunk('auth/getUserInfo', async (_, { getState }) => {
  const { accessToken } = getState().auth
  const response = await axiosConfig.get('/auth/me', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  sessionStorage.setItem('userInfo', JSON.stringify(response.data))

  return response.data
})

export const logoutUser = createAsyncThunk('auth/logout', async (_, { getState, dispatch }) => {
  const { accessToken } = getState().auth
  sessionStorage.clear()
  try {
    await axiosConfig.post('/auth/logout', null, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
  } catch (error) {
    console.error('Logout failed:', error.message)
  }
})

export const refreshAccessToken = createAsyncThunk(
  'auth/refreshAccessToken',
  async (_, { getState }) => {
    const { accessToken } = getState().auth
    const response = await axiosConfig.post('/auth/refresh', null, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    return response.data
  },
)

const initialState = {
  accessToken: sessionStorage.getItem('accessToken') || null,
  userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || null,
  loading: false,
  error: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // login thunk
      .addCase(loginUser.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.accessToken = action.payload.access_token
        state.loading = false
        state.error = null
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.accessToken = null
        state.loading = false
        if (action.error.message === 'Request failed with status code 401') {
          state.error = 'Email or password is incorrect'
        } else {
          state.error = action.error.message
        }
      })
      // Get user info thunk
      .addCase(getUserInfo.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getUserInfo.fulfilled, (state, action) => {
        state.userInfo = action.payload
        state.loading = false
        state.error = null
      })
      .addCase(getUserInfo.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
      // Log out thunk
      .addCase(logoutUser.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(logoutUser.fulfilled, () => {
        return { ...initialState, accessToken: null, userInfo: null }
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.accessToken = null
        state.userInfo = null
        state.loading = false
        state.error = action.error.message
      })
      // Refresh token thunk
      .addCase(refreshAccessToken.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(refreshAccessToken.fulfilled, (state, action) => {
        state.accessToken = action.payload.access_token
        state.loading = false
        state.error = null
      })
      .addCase(refreshAccessToken.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
  },
})

export const { clearAuthSession } = authSlice.actions

export default authSlice.reducer
